import { Dispatch, SetStateAction } from 'react';

import cookies from 'browser-cookies';
import {
	forgeAccessTokenExpiration,
	forgeRevalidationCookie,
} from '../../../types/authenticationContext.types';

export const checkForTokenExpiration = (
	setTimer: Dispatch<SetStateAction<number>>,
	setNeedTimerSet: Dispatch<SetStateAction<boolean>>,
): void => {
	const revalidationDate = cookies.get(forgeRevalidationCookie);
	const accessTokenExpiry = cookies.get(forgeAccessTokenExpiration);

	// Prefer the long-lived revalidation cookie (15-day session window).
	// Fall back to the access token expiry so the refresh cycle is not
	// permanently broken when the revalidation cookie is absent.
	const expirationDate = revalidationDate ?? accessTokenExpiry;

	if (expirationDate) {
		const date = new Date(expirationDate);
		if (date) {
			const difference = date.getTime() - new Date().getTime();
			if (difference > 0) {
				setTimer(difference);
				setNeedTimerSet(true);
			}
		}
	}
};
